export default __webpack_public_path__ + "static/media/ars-maquette-regular-webfont.d037c36d.eot";